import React, {useEffect} from "react";
import {
    setTargetExtension,
    setMappedExtensionFields,
    setRefreshSource,
    clearSettings,
    updateLoggingOut
} from "../store/settingsSlice";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../store/rootReducer";
import api, {
    useClearExtensionsMutation,
    useClearWorkspaceCacheMutation,

} from "../store/Api";
import {useClearSearchMutation} from "../store/endpoints/SavedSearchEndpoints";
import {useSetSelectedOrganizationMutation} from "../store/endpoints/OrganizationsEndpoints"

import {useMsal} from "@azure/msal-react";
import NotificationModal from "../components/Notification/NotificationModal";
import Footer from "../components/Layout/Footer";
import WorkspaceList from "../components/HomePage/WorkspaceList";
import FavoritesList from "../components/HomePage/FavoritesList";
import StorefrontList from "../components/HomePage/StorefrontList";
import IntegrationHealthList from "../components/HomePage/IntegrationHealthList";
import useCan, {ORG_EXTENSION_LOAD, STOREFRONT_READ} from '../permissions/ability';
import 'driver.js/dist/driver.css';
import { OPTIONAL_STEP_STOREFRONT, WELCOME_TOUR_KEY, WelcomeTour } from "../tours/WelcomeTour";
import usePageTour from '../hooks/usePageTour';


export const Home: React.FC = () => {
    const auth = useSelector((state: RootState) => state.auth);
    const org = useSelector((state: RootState) => state.settings.selectedOrganization);
    const dismissedNotification = useSelector((state: RootState) => state.settings.dismissedNotification);
    const [clearWorkspaces] = useClearWorkspaceCacheMutation();
    const [clearSearch] = useClearSearchMutation();
    const [setOrganization] = useSetSelectedOrganizationMutation();
    const [clearExtensions] = useClearExtensionsMutation();
    const {instance} = useMsal(); 
    const dispatch = useDispatch();
    const query = new URLSearchParams(location.search);
    const targetExtension = query.get('source');
    const refreshParentOnExtensionSubmit = query.get('refreshSource')
    const targetExtensionFields = query.get('mappedFields')
    const externalUsername = query.get('username')
    const checkOrg = query.get('acOrg')
    const canStorefrontRead = useCan(STOREFRONT_READ);
    const canLoadExtensions = useCan(ORG_EXTENSION_LOAD);

    const {
        tourOpen,
    } = usePageTour({
        tourKey: WELCOME_TOUR_KEY,
        tourDriver: WelcomeTour,
        enabledOptionalSteps: canStorefrontRead ? [OPTIONAL_STEP_STOREFRONT] : []
    });

    useEffect(() => {
        if (targetExtension && targetExtensionFields) {
            try {
                const mappedFields: { [key: string]: string; } = JSON.parse(targetExtensionFields)
                dispatch(setTargetExtension(targetExtension));
                dispatch(setMappedExtensionFields(mappedFields));
            } catch {
                console.log('Could not map fields.')
            }
        }
    }, [targetExtension, targetExtensionFields]);

    useEffect(() => {
        if (externalUsername) {
            if (auth.user?.email && auth.user.email.toLowerCase() != externalUsername.toLowerCase() ||
                (checkOrg && org && checkOrg != org)) {
                dispatch(updateLoggingOut(true));
                clearSearch();
                dispatch(clearSettings());
                clearWorkspaces();
                clearExtensions();
                setOrganization(undefined);
                dispatch(api.util.resetApiState());
                instance.logoutRedirect()
            }
        }
    }, [instance, externalUsername]);

    useEffect(() => {
        if (refreshParentOnExtensionSubmit) {
            dispatch(setRefreshSource(true))
        }
    }, [refreshParentOnExtensionSubmit]);

    return (<div className="main-content">
        {!dismissedNotification ? <NotificationModal/> : null}
        {org && 
        <div className="home-content">
            <div className="home-list-group">
                <WorkspaceList />
                <FavoritesList useDemoData={tourOpen} />
                {canStorefrontRead && <StorefrontList useDemoData={tourOpen} />}
                {canLoadExtensions && <IntegrationHealthList useDemoData={tourOpen} />}
            </div>
        </div>
        }
        <Footer/>
    </div>);
}

export default Home;
